import produce from 'immer';

// TYPES
import { Types, CadastrarMunicipioIbge } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: CadastrarMunicipioIbge = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarMunicipioIbge {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_MUNICIPIO_IBGE_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_IBGE_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_IBGE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_IBGE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
